import { render } from "./LeftArrow.vue?vue&type=template&id=6f70e408"
const script = {}

import exportComponent from "/Users/amir/Desktop/movie-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__